var map = {
	"./australia.png": 8920,
	"./austria.png": 4635,
	"./bahrain.png": 8749,
	"./belgium.png": 3617,
	"./bulgaria.png": 7239,
	"./canada.png": 1890,
	"./czech.png": 6207,
	"./estonia.png": 7643,
	"./france.png": 5325,
	"./germany.png": 5713,
	"./greece.png": 4613,
	"./hungary.png": 5696,
	"./iceland.png": 9052,
	"./ireland.png": 295,
	"./israel.png": 948,
	"./italy.png": 3527,
	"./japan.png": 1410,
	"./kuwait.png": 323,
	"./latvia.png": 8761,
	"./lithuania.png": 9063,
	"./malta.png": 9409,
	"./netherlands.png": 8386,
	"./norway.png": 7974,
	"./oman.png": 9205,
	"./poland.png": 8644,
	"./portugal.png": 8214,
	"./qatar.png": 3705,
	"./romania.png": 5155,
	"./saudi.png": 5370,
	"./slovakia.png": 1344,
	"./slovenia.png": 1085,
	"./spain.png": 937,
	"./sweden.png": 7828,
	"./switzerland.png": 6453,
	"./uae.png": 4597,
	"./uk.png": 264,
	"./usa.png": 971
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1566;